import config from '../config'
import http from '../http'
import {
  getQuotaWarningData as mockGetQuotaWarningData,
  getMarketData as mockGetMarketData,
  getRegisterData as mockGetRegisterData,
  getStatisticsData as mockGetStatisticsData,
  getCalculationData as mockGetCalculationData
} from '@/mock/carbonAsset'

export function getQuotaWarningData(params) {
  if (config.useMock) {
    return mockGetQuotaWarningData(params)
  }
  return http.get(`${config.api}/carbon/asset/quota-warning`, { params }).then(res => res.data)
}

export function getMarketData(params) {
  if (config.useMock) {
    return mockGetMarketData(params)
  }
  return http.get(`${config.api}/carbon/asset/market`, { params }).then(res => res.data)
}

export function getRegisterData(params) {
  if (config.useMock) {
    return mockGetRegisterData(params)
  }
  return http.get(`${config.api}/carbon/asset/register`, { params }).then(res => res.data)
}

export function getStatisticsData(params) {
  if (config.useMock) {
    return mockGetStatisticsData(params)
  }
  return http.get(`${config.api}/carbon/asset/statistics`, { params }).then(res => res.data)
}

export function getCalculationData(params) {
  if (config.useMock) {
    return mockGetCalculationData(params)
  }
  return http.get(`${config.api}/carbon/asset/calculation`, { params }).then(res => res.data)
}
